export default __webpack_public_path__ + "static/media/compeleteorders.02e16f59.svg";